import Seed from './icons/seed.svg'
import Initiative from './icons/initiative.svg'

export type IconNameTennis = keyof typeof iconsTennis;

export const iconsTennis = {
  'tennis-seed': Seed,
  'tennis-initiative': Initiative,
}
